export default "__VITE_PUBLIC_ASSET__4650e2a7__"